import React from 'react';

import { Flex, Spacer } from '@zillow/constellation';
import type { IconType } from '@zillow/constellation';

import { StyledLink, StyledNavItem, StyledText } from './StyledComponents';

type Props = {
  ActiveIcon?: React.ComponentType<React.PropsWithChildren<React.PropsWithChildren<typeof IconType>>> | null;
  InactiveIcon?: React.ComponentType<React.PropsWithChildren<React.PropsWithChildren<typeof IconType>>> | null;
  isActive?: boolean;
  title: string;
  toPath?: string;
  isInMenuPopper?: boolean;
};

const NavItem = ({
  title,
  isActive = false,
  toPath = '',
  ActiveIcon = null,
  InactiveIcon = null,
  isInMenuPopper,
}: Props) => {
  return (
    <StyledNavItem data-testid="NavItem" isInMenuPopper={isInMenuPopper}>
      <StyledLink
        isActive={isActive}
        to={{
          pathname: toPath,
        }}
      >
        <Flex
          display="flex"
          flexDirection={isInMenuPopper ? 'row' : 'column'}
          alignItems="center"
          justifyContent="center"
          data-testid="NavItem-ContentContainer"
        >
          <Flex
            display="flex"
            alignItems="center"
            marginRight={{ default: 'xs', md: 0 }}
            marginBottom={{ default: 0, md: 'xs' }}
          >
            {isActive ? ActiveIcon && <ActiveIcon size="sm" /> : InactiveIcon && <InactiveIcon size="sm" />}
          </Flex>
          <Spacer marginBottom={isInMenuPopper ? 0 : 'sm'}>
            <StyledText
              isActive={isActive}
              fontType={{
                default: isActive ? 'finePrintHeading' : 'finePrint',
                md: isActive ? 'bodyHeading' : 'body',
              }}
            >
              {title}
            </StyledText>
          </Spacer>
        </Flex>
      </StyledLink>
    </StyledNavItem>
  );
};

export default NavItem;
